module.exports = __webpack_public_path__ + "static/img/qrcode-wx-zhang.db7bbb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-wx-zhang.png
// module id = ag5g
// module chunks = 0